import { Enum } from './Enum';

export class ChatRoomTypeEnum extends Enum {
    static Direct = 'direct';
    static Group = 'group';
}

